import { RouteComponentProps } from 'react-router-dom';
import qs from 'query-string';
import { AppDispatch } from 'src/store';
import { IQueryParams } from 'src/types';
import { removeEmpty } from 'src/utils/removeEmpty';
import { createAction } from '@reduxjs/toolkit';

import { IHint, IHintListData } from '../hints/types';

import { createHintSiteRequest, fetchHintsSitePageRequest, updateHintSiteRequest } from './requestHandlers';

const defaultParams = {
  page: '0',
  size: '10',
};

export const loadHintsSiteStart = createAction('hints_site/load/start');
export const loadHintsSiteSuccess = createAction<IHintListData>('hints_site/load/success');

export const fetchHintsSitePage = (history: RouteComponentProps['history'], params: IQueryParams = {}, type?: string) => {
  return async (dispatch: AppDispatch): Promise<boolean> => {
    dispatch(loadHintsSiteStart());
    const initialParams = qs.parse(history.location.search);
    const mergedParams = type === 'reset' ? defaultParams : removeEmpty({ ...defaultParams, ...initialParams, ...params });
    const data = await fetchHintsSitePageRequest(mergedParams);
    if (data) {
      dispatch(loadHintsSiteSuccess(data));
    }
    history.replace({
      search: qs.stringify(mergedParams, { skipNull: true }),
    });
    return true;
  };
};

export const createHintSite = async (data: Partial<IHint>): Promise<Partial<IHint>> => createHintSiteRequest(data);

export const updateHintSite = async (data: Partial<IHint>): Promise<Partial<IHint>> => updateHintSiteRequest(data);
